import React from "react";
import { Avatar, Box, Paper, Stack, Typography, alpha } from "@mui/material";
import TabOutlinedIcon from "@mui/icons-material/TabOutlined";
import { navItems } from "./utils/navigationSettings";

const pageDescriptions = {
  contentPage: "Review the sections in your tax computation.",
  mainComputationData: "Work on your main tax computation.",
  detailPL: "Review the detailed profit and loss figures.",
};

const ConsoleEmptyState = () => (
  <Box
    sx={{
      minHeight: "100%",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: { xs: 2, sm: 3, lg: 4 },
    }}
  >
    <Paper
      component='section'
      aria-labelledby='console-empty-title'
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: 560,
        minWidth: 0,
        p: { xs: 2.5, sm: 4 },
        border: 1,
        borderColor: "divider",
        borderRadius: 3,
        boxShadow: "0 3px 16px rgba(30,20,50,0.025)",
      }}
    >
      <Stack spacing={1.5} alignItems='center' sx={{ textAlign: "center" }}>
        <Avatar
          variant='rounded'
          sx={{
            width: 48,
            height: 48,
            borderRadius: 3,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            color: "primary.main",
          }}
        >
          <TabOutlinedIcon />
        </Avatar>
        <Box>
          <Typography
            id='console-empty-title'
            component='h2'
            variant='h6'
            fontWeight={700}
          >
            Open a page to get started
          </Typography>
          <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
            Choose a page from the navigation menu. It will open in a tab here.
          </Typography>
        </Box>
      </Stack>

      <Box sx={{ mt: 3, pt: 2.5, borderTop: 1, borderColor: "divider" }}>
        <Typography variant='subtitle2' fontWeight={700}>
          Common pages
        </Typography>
        <Stack
          component='ul'
          spacing={2}
          sx={{ m: 0, mt: 2, p: 0, listStyle: "none" }}
        >
          {navItems
            .filter((item) => pageDescriptions[item.sectionKey])
            .map((item) => (
              <Stack
                component='li'
                direction='row'
                spacing={1.5}
                key={item.sectionKey}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 36,
                    height: 36,
                    flexShrink: 0,
                    borderRadius: 2,
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.05),
                    color: "primary.main",
                    "& .MuiSvgIcon-root": { fontSize: 20 },
                  }}
                >
                  {item.icon}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography variant='body2' fontWeight={600}>
                    {item.label}
                  </Typography>
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    sx={{ mt: 0.25 }}
                  >
                    {pageDescriptions[item.sectionKey]}
                  </Typography>
                </Box>
              </Stack>
            ))}
        </Stack>
      </Box>
    </Paper>
  </Box>
);

export default ConsoleEmptyState;
